import { render, staticRenderFns } from "./z5storeTransfer.vue?vue&type=template&id=6d2b7558&"
import script from "./z5storeTransfer.vue?vue&type=script&lang=js&"
export * from "./z5storeTransfer.vue?vue&type=script&lang=js&"
import style0 from "./z5storeTransfer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports